import { render, staticRenderFns } from "./Widget.vue?vue&type=template&id=4ca8e912&scoped=true"
import script from "./Widget.vue?vue&type=script&lang=js"
export * from "./Widget.vue?vue&type=script&lang=js"
import style0 from "./Widget.vue?vue&type=style&index=0&id=4ca8e912&prod&scoped=true&lang=scss"
import style1 from "./Widget.vue?vue&type=style&index=1&id=4ca8e912&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4ca8e912",
  null
  
)

export default component.exports